import React from "react";
import { EquipmentItem as EquipmentItemType } from "./types";

interface EquipmentItemProps {
  item: EquipmentItemType;
  onUpdateQuantity: (itemId: string, delta: number) => void;
}

export const EquipmentItem: React.FC<EquipmentItemProps> = ({
  item,
  onUpdateQuantity,
}) => {
  const handleIncrease = (item: EquipmentItemType) => {
    item.quantity = item.quantity?item.quantity:0;
    //console.log(item.quantity, item.maxQuantity)
    if (item.quantity < (item.maxQuantity - item.busy)) {
      onUpdateQuantity(item.id, 1);
    }
  };

  const getClass = (item: EquipmentItemType) => {
    if (item.maxQuantity - item.busy > 0) {
      return "flex gap-2.5 items-center";
    } else {
      return "flex gap-2.5 items-center opacity-40";
    }
  };

  const getStatus = (item: EquipmentItemType) => {
    if (item.maxQuantity - item.busy > 0) {
      return "";
    } else {
      return "(на это время все уже разобрали)";
    }
  };

  return (
    <div className="flex flex-col gap-4 p-3 border border-solid border-neutral-200">
      <div className="flex gap-4 items-center">
      {item.icon && (
        <img className="w-16 h-16" src={item.icon} alt={item.name} />
        )}
        <div className="text-sm font-light">{item.name}<div className="text-xs text-gray-500">{getStatus(item)}</div></div>
        
      </div>
      <div  className="flex w-full justify-between">
        <div className="text-sm font-medium text-amber-500">
          <span>{item.price}</span>
          <span> ₽</span>
        </div>
        <div className={getClass(item)}>
          <button
            className="border border-solid cursor-pointer border-neutral-200 h-[30px] w-[30px]"
            onClick={() => onUpdateQuantity(item.id, -1)}
          >
            -
          </button>
          <span className="text-sm text-center w-[30px]">
            {item.quantity || 0}
          </span>
          <button
            className="border border-solid cursor-pointer border-neutral-200 h-[30px] w-[30px]"
            onClick={() => handleIncrease(item)}
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
};
